import { UnaryOperator } from 'dashboard/apps/InquiryTemplateEditor/InquiryTemplateScreenComponentEditor/ComponentEditorSections/ComponentJsonLogicEditor/types';
import { LogicBlockOrV2 } from 'dashboard/lib/workflows';
import { WorkflowOperatorKey } from 'dashboard/models/workflow';

export const SERVER_VALUES_PREFIX = 'field_values';
export const CLIENT_VALUES_PREFIX = 'form';

export const INVERTED_RULE_SUFFIX = '-inverted';
export const SERVER_EVALUATED_SUFFIX = '-server-evaluated';

export const DEFAULT_LOGIC_RULE_BLOCK: { rules: LogicBlockOrV2 } = {
  rules: {
    or: [
      {
        and: [{}],
      },
    ],
  },
};

export const UNARY_OPERATORS: UnaryOperator[] = [
  WorkflowOperatorKey.IsBlank,
  WorkflowOperatorKey.IsNotBlank,
  WorkflowOperatorKey.IsFalsy,
  WorkflowOperatorKey.IsTruthy,
];
